// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3NzAV","selected":"Chip_selected__1S6yb"};